<template>
  <img
    :class="loaderCustomClasses"
    alt="Loading"
    class="icon-moon-loading rotating"
    src="@/assets/whiteMoonLogo.svg"
  />
</template>
<script lang="ts" setup>
import { computed, toRefs } from "vue";
import type { CustomClasses } from "@/models/customClasses";

const props = defineProps<{
  colour: "black" | "white";
  customClasses?: CustomClasses;
}>();

const { colour, customClasses } = toRefs(props);

const loaderCustomClasses = computed(() => {
  const base = customClasses?.value ?? {};
  if (colour.value === "black") {
    base["invert"] = true;
  }
  return base;
});
</script>
<style scoped>
.rotating {
  animation: rotating 2s linear infinite;
  transform-origin: 53.12% 53.12%;
}

img {
  width: 50%;
  height: 50%;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
